export default [
  {
    path: '/admin/notification/telegram-messages',
    name: 'telegram-message',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification/telegram-message/index.vue')
  },
  {
    path: '/admin/notification/telegram-messages/create',
    name: 'telegram-message-create',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification/telegram-message/create.vue')
  },
  {
    path: '/admin/notification/telegram-messages/:id/edit',
    name: 'telegram-message-edit',
    meta: { requiresAuth: true },
    component: () => import('@/pages/notification/telegram-message/edit.vue')
  }
]
